// @flow
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

import MenuHeader from '../components/MenuHeader/MenuHeader';
import Footer from '../components/Footer/Footer';
import Search from './components/Search/Search';
import AdminList from './components/AdminList/AdminList';
import AdminSettings from './components/AdminSettings/AdminSettings';

class Admins extends Component<Object, {
  filter: string,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      filter: '',
    };
  }

  addNewAdmin() {
    this.adminSettings.open({ email: '', groupName: '', userIds: [] }, true);
  }

  openAdmin(admin: Object) {
    this.adminSettings.open(admin, false);
  }

  changeFilter(value: string) {
    this.setState({ filter: value });
  }

  adminSettings: Object = {};
  adminList: Object = {};

  render(): React.Node {
    return (<div>
      <MenuHeader active="admins" />
      <div className="container">
        <Search onChange={(v: string) => this.changeFilter(v)} />
        <AdminList
          ref={(instance: Object) => { this.adminList = instance; }}
          onAdminSelected={(admin: Object) => this.openAdmin(admin)}
          filter={this.state.filter}
        />
        <Button onClick={() => this.addNewAdmin()}>Add</Button>
        <AdminSettings
          ref={(instance: Object) => { this.adminSettings = instance; }}
          onClose={() => { this.adminList.loadList(); }}
        />
      </div>
      <Footer />
    </div>);
  }
}

export default Admins;



// WEBPACK FOOTER //
// ./src/scenes/Admins/Admins.js